import { Box, Typography } from "@mui/material"

export default function ReportTile(props) {
    const { title, value } = props
    return <Box sx={{ width: "100%", paddingBlock: "0.2em", paddingInline: "0.5em", backgroundColor: 'background.main', borderRadius: "0.5em", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
        <Typography>{title}</Typography>
        <Typography>{value}</Typography>
    </Box>
}